import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_learning/discover/channels/_overview/',
)()
